import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import NotFoundPage from '../pages/NotFoundPage';
import { useEntitlements } from '../shell/EntitlementsContext';
const ToolRouteGuard = ({ slug, children }) => {
    const { tools, loading } = useEntitlements();
    if (loading)
        return null;
    const isEntitled = tools.some((t) => t.slug === slug);
    if (!isEntitled)
        return _jsx(NotFoundPage, {});
    return _jsx(_Fragment, { children: children });
};
export default ToolRouteGuard;
